import React, { useEffect, useMemo } from 'react';

import { toast } from 'react-toastify';

import Input from 'Components/Input';
import useReducedErrors from 'Shared/hooks/useReducedErrors';
import useNightMode from 'Shared/hooks/useNightMode';
import ToggleButton from 'Components/ToggleButton/ToggleButton';

const transitionMode = () => {
  document.documentElement.classList.add('transition');
  window.setTimeout(() => {
    document.documentElement.classList.remove('transition');
  }, 1000);
};

const toastParams = {
  autoClose: 3000,
  closeButton: true,
  hideProgressBar: false,
};

const TabPersonalCustomer = (props) => {
  const {
    formik: {
      values: { firstName, lastName, email, title, address1, zip, country, city, emailBusiness },
      errors,
      handleBlur,
      handleChange,
      setValues,
      validateForm,
    },
    data,
  } = props;

  useMemo(() => {
    if (data && data.user.customerprofile) {
      let company = {
        country: '',
        city: '',
        title: '',
        address1: '',
        zip: '',
        email: '',
      };
      if (data.user.customerprofile.contact.company) {
        const { country, city, title, address1, zip, email } = data.user.customerprofile.contact.company;
        company = {
          country,
          city,
          title,
          address1,
          zip,
          email,
        };
      } else {
        toast('You don`t have company', {
          ...toastParams,
          type: toast.TYPE.ERROR,
        });
      }
      setValues(
        ((
          {
            user: {
              email,
              id,
              customerprofile: {
                contact: { firstName, lastName },
              },
            },
          },
          { country, city, title, address1, zip, email: emailBusiness }
        ) => ({
          firstName,
          lastName,
          email,
          title,
          address1,
          zip,
          country,
          city,
          emailBusiness,
          id,
        }))(data, company)
      );
    }
  }, [data, setValues]);

  useEffect(() => {
    validateForm();
    //cache data until user closes Profile tab
    const localStoragePersonalData = JSON.parse(localStorage.getItem('personalCustomerData'));
    if (localStoragePersonalData) {
      setValues(localStoragePersonalData);
    }
  }, [data, setValues, validateForm]);

  useEffect(() => {
    localStorage.setItem(
      'personalCustomerData',
      JSON.stringify({
        firstName,
        lastName,
        email,
        title,
        address1,
        zip,
        country,
        city,
        emailBusiness,
      })
    );
  }, [address1, city, country, email, emailBusiness, firstName, lastName, title, zip]);

  const reducedErrors = useReducedErrors(errors);
  const [nightMode, updateNightMode] = useNightMode();

  const onChangeColorMode = () => {
    const status = nightMode;
    localStorage.setItem('nightMode', !status);

    if (!status) {
      transitionMode();
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      transitionMode();
      document.documentElement.setAttribute('data-theme', 'light');
    }
  };

  return (
    <div className="profile-tab customer-profile" data-testid="profile-tab-customer">
      <div className="profile-tab__section">
        <Input
          label="Your email"
          helperVariant={reducedErrors['email'] ? 'error' : 'message'}
          helper={reducedErrors['email']}
          id="email"
          fieldProps={{
            placeholder: 'Enter your email',
            name: 'email',
            value: email,
            onChange: handleChange,
            onBlur: handleBlur,
          }}
        />
        <Input
          label="First name"
          helperVariant={reducedErrors['firstName'] ? 'error' : 'message'}
          helper={reducedErrors['firstName']}
          id="firstName"
          fieldProps={{
            placeholder: 'Enter first name',
            name: 'firstName',
            value: firstName,
            onChange: handleChange,
            onBlur: handleBlur,
          }}
          disabled={true}
        />
        <Input
          label="Last name"
          helperVariant={reducedErrors['lastName'] ? 'error' : 'message'}
          helper={reducedErrors['lastName']}
          id="lastName"
          fieldProps={{
            placeholder: 'Enter last name',
            name: 'lastName',
            value: lastName,
            onChange: handleChange,
            onBlur: handleBlur,
          }}
          disabled={true}
        />
      </div>
      <div className="profile-tab__night-mode">
        <ToggleButton
          extractToggle={true}
          onToggleChange={() => {
            onChangeColorMode();
            updateNightMode(!nightMode);
          }}
          toggleStatus={nightMode}
          inversion={true}
          id={'night-mode'}
        />
        <p className="night-mode__label">Night mode</p>
      </div>
    </div>
  );
};

export default TabPersonalCustomer;
